import Breadcrumb from "../../Component/Breadcrumb";

function GeneralRules() {
  return (
    <>
      <Breadcrumb>Policies / General Rules</Breadcrumb>
      <div className="innersec">
        <div className="container">
          <div className="col-lg-12">
            <h1>General Rules</h1>
          </div>
          <div className="recommendations-section">
            <div className="recommendations-card shadow-sm rounded-4 bg-white">
              <ol className="modern-list">
                <li>
                  Students are urged to contribute to the high tone of the
                  school by their manners and general behaviour. Hence, for the
                  smooth running of the school, no student should bring to
                  school any object liable to prove a source of disturbance.
                </li>

                <li>
                  Absolute silence must be maintained at all places during the
                  teaching hours, whether it is the library, the computer room,
                  the general assembly or on way to and from the classroom etc.
                </li>

                <li>
                  It is compulsory to speak in English in the premises in order
                  to facilitate the students the use of the medium of
                  instruction. They should maintain a high standard in their
                  conversation.
                </li>

                <li>
                  The General Assembly is the most important part of the school
                  day. Every student should be present at it to begin the day
                  with prayer to God and listen to the important announcements.
                </li>

                <li>
                  Students should keep their classroom and their school compound
                  spotlessly clean using the bins provided for waste papers and
                  rubbish.
                </li>

                <li>
                  Students repeatedly coming late or forgetting to bring books
                  or coming without the proper uniform may be punished.
                </li>

                <li>
                  All the pupils should be in school on the first day of each
                  term without fail. Regular attendance is a pre-requisite to
                  good education and an important factor in deciding promotion.
                </li>

                <li>
                  All must come to school in time, neatly dressed with lessons
                  well prepared and homework done. Text and exercise book and
                  material for drawing, art craft should be brought to school
                  according to the day’s routine.
                </li>

                <li>
                  Students should arrive at the school 10 minutes before the
                  assembly. Soon after the assembly bell, the school gate will
                  be locked and the late comers will return home at the parents'
                  risk.
                </li>

                <li>
                  A minimum attendance of 80% of the working days is needed to
                  qualify a student for promotion, hence the need of regular
                  attendance is compulsory.
                </li>

                <li>
                  No leaves of absence are given without a previous application
                  in writing from the guardian. All leave must be applied for in
                  writing addressed to the principal. No student shall proceed
                  on leave without sanction and permission specially when the
                  leave exceeds two days.
                </li>

                <li>Students must be regular and punctual in the school.</li>

                <li>
                  Fee must be paid regularly. A student's name is liable to be
                  struck off if the fees are in arrears at the end of the
                  respective quarter.
                </li>

                <li>
                  Students may be required to attend extra classes on any
                  working day after school hours, or on holidays, provided they
                  have been informed on the previous day. Students themselves
                  must make the alternative arrangement for their conveyance
                  etc. if necessary.
                </li>

                <li>
                  All students will have to take part in the extra-curricular
                  activities, co-curricular activities, drill etc. No requests
                  for exemption will be entertained. If physically unfit a
                  medical certificate should be produced.
                </li>

                <li>
                  No student is allowed to bring mobile phone, camera, radio,
                  out of course books, newspapers, periodicals, pictures, games
                  articles, or any electrical instruments not pertaining to
                  their daily use to the school without prior permission; if
                  found in possession, they will be rusticated from the school
                  without any prior notice.
                </li>

                <li>
                  The school does not accept responsibility for the loss of
                  books, money, stationery etc. Each student is responsible for
                  his/her own things. Bringing of valuables to the school is
                  discouraged.
                </li>

                <li>
                  All children are expected to bring the tiffin with them for
                  the noon recess.
                </li>

                <li>
                  Pupil suffering from contagious or infectious disease should
                  not attend school.
                </li>

                <li>
                  Students shall not offer gifts or presents to their teachers.
                </li>

                <li>
                  Parents must intimate the school whenever their residential
                  address or telephone numbers are changed in order to
                  communicate to them in urgent matters in the interest of their
                  children.
                </li>

                <li>
                  Parents are requested not to send for or call away their
                  children during class hours except in case of unforeseen
                  emergency and that too with the Principal's Permission.
                </li>

                <li>
                  If a student is likely to be absent through illness for a long
                  period, the principal/class teacher must be informed
                  immediately through an application with the name, class and
                  section of their ward.
                </li>

                <li>Tuitions are strongly discouraged.</li>

                <li>
                  Parents/Guardians are requested not to give any money to the
                  children unless they receive a written notice from the school.
                  Children should be provided with tiffin, so that they do not
                  have to buy any eatables from anywhere.
                </li>

                <li>
                  No guardian is allowed to go into any classroom without the
                  specific permission from school authorities.
                </li>

                <li>
                  Continuance on the rolls of the school is subject to
                  satisfactory progress in studies. Any student who fails for
                  the second consecutive year in the same class will not be
                  permitted to continue in the school.
                </li>

                <li>
                  Request for leave on medical ground must be supported by
                  certificate of a registered medical practitioner.
                </li>

                <li>
                  Attendance is compulsory on days such as Independence Day,
                  Republic Day, Teachers’ Day, Children’s Day, Gandhi Jayanti,
                  opening and closing days of the academic year, opening and
                  closing days of the holidays and on other days specially asked
                  by the school.
                </li>

                <li className="student-rule">
                  <strong className="rule-title">
                    Pupils are not allowed to:
                  </strong>

                  <div className="row mt-3 g-3 rule-boxes">
                    <div className="col-lg-4 col-md-6">
                      <div className="rule-card h-100">
                        <div className="rule-icon">
                          <i className="bi bi-shop"></i>
                        </div>
                        <p className="rule-text">
                          Buy sweets and other eatables at the school gate.
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="rule-card h-100">
                        <div className="rule-icon">
                          <i className="bi bi-person-workspace"></i>
                        </div>
                        <p className="rule-text">
                          Take private tuition in any subject from any member of
                          the staff.
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="rule-card h-100">
                        <div className="rule-icon">
                          <i className="bi bi-exclamation-octagon"></i>
                        </div>
                        <p className="rule-text">
                          Enter a classroom other than their own.
                        </p>
                        <p className="rule-text">
                          Coming to the school by two-wheeler is strictly
                          prohibited.
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ol>

              <h4>Note:</h4>
              <p>
                The principal reserves the right to waive any of the rules
                contained in this book without assigning any reason for his
                action and it will be binding on Parents/Guardians and Students.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default GeneralRules;
